import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoujjaincab() {



const cardData = {
  keyword: "Pune to Ujjain Cab",

"headingDescription": "Pune to Ujjain Cab service provides a reliable, comfortable, and convenient travel solution for pilgrims, families, and travelers heading to the historic city of Ujjain. SRS Cab Service ensures a smooth journey with experienced drivers, well-maintained vehicles, and timely pickups. Ideal for spiritual trips, sightseeing, and group travel, our service offers flexible booking options, transparent fares, and 24/7 support, making your Pune to Ujjain journey stress-free and enjoyable.",
"topPlaces": [
  {
    "title": "Mahakaleshwar Jyotirlinga Temple",
    "description": "Mahakaleshwar Temple is one of the twelve Jyotirlingas and a major pilgrimage site in Ujjain. Travelers booking Pune to Ujjain Cab often visit this sacred temple to seek blessings and experience its spiritual aura."
  },
  {
    "title": "Kal Bhairav Temple",
    "description": "Kal Bhairav Temple is dedicated to Lord Bhairav and is famous for its unique rituals. Visitors using Pune to Ujjain Cab frequently stop here during their spiritual journey."
  },
  {
    "title": "Harsiddhi Temple",
    "description": "Harsiddhi Temple is an ancient temple known for its beautiful architecture and religious significance. Travelers using Pune to Ujjain Cab often include this site in their itinerary."
  },
  {
    "title": "Ram Ghat",
    "description": "Ram Ghat is a historic ghat on the Shipra River where pilgrims gather for rituals. Visitors booking Pune to Ujjain Cab often visit this serene location for spiritual activities and photography."
  },
  {
    "title": "Chintaman Ganesh Temple",
    "description": "Chintaman Ganesh Temple is one of the oldest temples in Ujjain dedicated to Lord Ganesha. Travelers using Pune to Ujjain Cab often pay their respects and experience its peaceful ambiance."
  },
  {
    "title": "Vedh Shala (Observatory)",
    "description": "Vedh Shala is an ancient observatory built by Maharaja Jai Singh II. Visitors using Pune to Ujjain Cab often explore this site to learn about historical astronomical practices."
  },
  {
    "title": "Gopal Mandir",
    "description": "Gopal Mandir is a beautiful temple dedicated to Lord Krishna. Travelers using Pune to Ujjain Cab frequently include this temple in their sightseeing route."
  },
  {
    "title": "Bade Ganeshji Ka Mandir",
    "description": "Bade Ganeshji Ka Mandir is a famous temple dedicated to Lord Ganesha, known for its large idol. Visitors using Pune to Ujjain Cab often stop here during their spiritual journey."
  },
  {
    "title": "ISKCON Ujjain",
    "description": "ISKCON Ujjain is a spiritual center dedicated to Lord Krishna and devotional activities. Travelers using Pune to Ujjain Cab often visit for a calm and spiritual experience."
  },
  {
    "title": "Sandipani Ashram",
    "description": "Sandipani Ashram is an ancient ashram where devotees engage in meditation and spiritual learning. Visitors using Pune to Ujjain Cab include this place in their pilgrimage itinerary."
  }
],



services: [
{
name: "Pune to Ujjain Cab",
description: "Pune to Ujjain cab offers reliable long-distance travel for pilgrimage and tourism. Customers can book cabs for comfortable journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance long-distance experience. Flexible booking options are available. Travel easily from Pune to Ujjain with cab services."
},
{
name: "Pune to Ujjain Taxi",
description: "Pune to Ujjain taxi provides convenient transportation for long journeys. Customers can book taxis for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily from Pune to Ujjain with taxi services."
},
{
name: "Pune to Ujjain Cab Service",
description: "Pune to Ujjain cab service offers dependable transportation for intercity travel. Customers can book cabs for one-way or round trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Choose cab services for Pune to Ujjain travel."
},
{
name: "Pune to Ujjain Taxi Service",
description: "Pune to Ujjain taxi service provides reliable travel for long-distance trips. Customers can book taxis for business and pilgrimage journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with taxi services."
},
{
name: "Pune to Ujjain Cab Booking",
description: "Pune to Ujjain cab booking offers quick and easy reservation options. Customers can book cabs online or via mobile apps. Professional drivers ensure safe journeys. Comfortable vehicles enhance travel comfort. Flexible booking options are available. Book your Pune to Ujjain cab easily."
},
{
name: "Pune to Ujjain Taxi Booking",
description: "Pune to Ujjain taxi booking provides convenient booking options for travelers. Customers can reserve taxis instantly online. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi from Pune to Ujjain easily."
},
{
name: "Pune to Ujjain One Way Cab",
description: "Pune to Ujjain one way cab offers economical travel without return charges. Customers can book direct rides easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose one-way cab services for Pune to Ujjain."
},
{
name: "Pune to Ujjain One Way Taxi",
description: "Pune to Ujjain one way taxi provides convenient travel for single-direction journeys. Customers can book taxis easily. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with one-way taxi services."
},
{
name: "Pune to Ujjain Cab Fare",
description: "Pune to Ujjain cab fare provides detailed pricing for travel planning. Customers can compare fares before booking rides. Affordable pricing ensures budget-friendly travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Travel confidently with cab fare services."
},
{
name: "Pune to Ujjain Taxi Price",
description: "Pune to Ujjain taxi price offers clear pricing details for travelers. Customers can check rates before booking rides. Affordable pricing ensures cost-effective travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Choose taxi services with transparent pricing."
},
{
name: "Pune to Ujjain Cab Hire",
description: "Pune to Ujjain cab hire offers flexible travel solutions for long-distance trips. Customers can hire vehicles for personal and business travel. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Hire cabs from Pune to Ujjain easily."
},
{
name: "Pune to Ujjain Taxi Hire",
description: "Pune to Ujjain taxi hire provides convenient transportation for travelers. Customers can hire taxis for flexible schedules. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose taxi hire services for Pune to Ujjain travel."
},
{
name: "Pune to Ujjain Outstation Cab",
description: "Pune to Ujjain outstation cab offers reliable travel for long-distance trips. Customers can book cabs for one-way or round journeys. Professional drivers ensure safe highway travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with outstation cab services."
},
{
name: "Pune to Ujjain Outstation Taxi",
description: "Pune to Ujjain outstation taxi provides dependable travel for extended journeys. Customers can book taxis for flexible travel plans. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with outstation taxi services."
},
{
name: "Pune to Ujjain Drop Cab",
description: "Pune to Ujjain drop cab offers direct one-way transportation services. Customers can book cabs for convenient drop journeys. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Choose drop cab services from Pune to Ujjain."
},
{
name: "Pune to Ujjain Drop Taxi",
description: "Pune to Ujjain drop taxi provides convenient travel for direct trips. Customers can book taxis without return charges. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Transparent pricing ensures affordability. Travel easily with drop taxi services."
},
{
name: "Pune to Ujjain Cab Online Booking",
description: "Pune to Ujjain cab online booking offers instant reservation options. Customers can book cabs digitally with ease. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your cab online from Pune to Ujjain."
},
{
name: "Pune to Ujjain Taxi Online Booking",
description: "Pune to Ujjain taxi online booking provides quick and easy booking options. Customers can reserve taxis instantly online. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Book your taxi easily online."
},
{
name: "Pune to Ujjain Cab for Trip",
description: "Pune to Ujjain cab for trip offers comfortable travel for long-distance journeys. Customers can plan multi-day trips easily. Professional drivers ensure safe travel. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily with cab services for trips."
},
{
name: "Pune to Ujjain Darshan Cab",
description: "Pune to Ujjain darshan cab offers spiritual travel for Mahakal temple visits. Customers can book cabs for pilgrimage trips. Professional drivers ensure safe journeys. Comfortable vehicles enhance experience. Flexible booking options are available. Travel easily for darshan from Pune."
},
{
name: "Innova Cab Pune to Ujjain",
description: "Innova cab Pune to Ujjain offers premium SUV travel for long journeys. Customers can enjoy spacious seating and comfort. Professional drivers ensure safe travel. Ideal for family trips. Transparent pricing ensures value for money. Travel comfortably with Innova cab services."
},
{
name: "Innova Crysta Cab Pune to Ujjain",
description: "Innova Crysta cab Pune to Ujjain provides luxury travel for long-distance journeys. Customers can enjoy premium comfort and space. Professional drivers ensure safe travel. Ideal for group trips. Transparent pricing ensures value for money. Travel easily with Innova Crysta services."
},
{
name: "Ertiga Cab Pune to Ujjain",
description: "Ertiga cab Pune to Ujjain offers comfortable 7-seater travel for families. Customers can enjoy smooth long-distance journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with Ertiga cab services."
},
{
name: "Dzire Cab Pune to Ujjain",
description: "Dzire cab Pune to Ujjain provides economical travel for long-distance trips. Customers can book sedans for budget-friendly journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Transparent pricing ensures affordability. Travel easily with Dzire cab services."
},
{
name: "Sedan Cab Pune to Ujjain",
description: "Sedan cab Pune to Ujjain offers cost-effective travel for individuals and small groups. Customers can book vehicles for comfortable journeys. Professional drivers ensure safe travel. Comfortable seating enhances experience. Flexible booking options are available. Travel easily with sedan cab services."
},
{
name: "SUV Cab Pune to Ujjain",
description: "SUV cab Pune to Ujjain provides spacious travel for long-distance trips. Customers can enjoy comfortable seating and luggage space. Professional drivers ensure safe travel. Ideal for family and group journeys. Flexible booking options are available. Travel easily with SUV cab services."
},
{
name: "Luxury Cab Pune to Ujjain",
description: "Luxury cab Pune to Ujjain offers premium travel experience for long-distance journeys. Customers can enjoy high-end vehicles with extra comfort. Professional drivers ensure safe travel. Ideal for corporate and VIP travel. Flexible booking options are available. Travel comfortably with luxury cab services."
}
],

tableData: [
["Pune to Ujjain Cab","Pune to Ujjain Taxi"],
["Pune to Ujjain Cab Service","Pune to Ujjain Taxi Service"],
["Pune to Ujjain Cab Booking","Pune to Ujjain Taxi Booking"],
["Pune to Ujjain One Way Cab","Pune to Ujjain One Way Taxi"],
["Pune to Ujjain Cab Fare","Pune to Ujjain Taxi Price"],
["Pune to Ujjain Cab Hire","Pune to Ujjain Taxi Hire"],
["Pune to Ujjain Outstation Cab","Pune to Ujjain Outstation Taxi"],
["Pune to Ujjain Drop Cab","Pune to Ujjain Drop Taxi"],
["Pune to Ujjain Cab Online Booking","Pune to Ujjain Taxi Online Booking"],
["Pune to Ujjain Cab for Trip","Pune to Ujjain Darshan Cab"],
["Innova Cab Pune to Ujjain","Innova Crysta Cab Pune to Ujjain"],
["Ertiga Cab Pune to Ujjain","Dzire Cab Pune to Ujjain"],
["Sedan Cab Pune to Ujjain","SUV Cab Pune to Ujjain"],
["Luxury Cab Pune to Ujjain","Pune to Ujjain Cab"]
],



whychoose: [
  {
    WhyChooseheading: "Experienced Long-Distance Route Drivers",
    WhyChoosedescription: "SRS Cab Service provides expert drivers experienced in Pune to Ujjain routes, ensuring safe highway driving, proper rest planning, and smooth intercity travel."
  },
  {
    WhyChooseheading: "Affordable Pune to Ujjain Cab Pricing",
    WhyChoosedescription: "We offer budget-friendly Pune to Ujjain cab services with transparent pricing. Customers receive complete fare details including tolls, state taxes, and driver allowance with no hidden charges."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "SRS Cab Service operates 24/7 for Pune to Ujjain cab bookings, making it convenient for pilgrimage travel, family trips, and urgent long-distance journeys."
  },
  {
    WhyChooseheading: "Comfortable & AC Vehicles for Long Travel",
    WhyChoosedescription: "Our fleet includes clean, well-maintained, and air-conditioned vehicles designed for long-distance comfort, ensuring a relaxed journey from Pune to Ujjain."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "We provide one-way cab service, round-trip bookings, and customized travel plans for Pune to Ujjain journeys based on customer requirements."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "Choose from sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers suitable for individual, family, and group travel."
  },
  {
    WhyChooseheading: "Doorstep Pickup Across Pune",
    WhyChoosedescription: "We offer convenient pickup from homes, hotels, offices, and Pune Airport across all major areas including Hinjewadi, Wakad, Baner, and Hadapsar."
  },
  {
    WhyChooseheading: "Trusted Pilgrimage Cab Service",
    WhyChoosedescription: "SRS Cab Service is trusted for Pune to Ujjain cab bookings due to reliable service, professional drivers, and smooth travel experience for temple visits."
  }
]
}

const faqData = [
  { question: "Do you provide Pune to Ujjain cab service?", answer: "Yes, SRS Cab Service offers reliable cab services from Pune to Ujjain for comfortable long-distance travel." },
  { question: "How far is Ujjain from Pune?", answer: "The distance between Pune and Ujjain is approximately 650 km and the journey takes around 12 to 14 hours depending on route and traffic." },
  { question: "Is Pune to Ujjain cab service available 24 hours?", answer: "Yes, our cab service operates 24/7 for flexible travel planning." },
  { question: "Which vehicles are available for Pune to Ujjain travel?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, luxury Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab from Pune to Ujjain?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Do you provide multi-day travel options?", answer: "Yes, we offer customized multi-day travel plans for Pune to Ujjain journeys." },
  { question: "Are vehicles suitable for long-distance travel?", answer: "Yes, all vehicles are well-maintained and suitable for long-distance journeys." },
  { question: "Can I book the cab online?", answer: "Yes, you can easily book Pune to Ujjain cab service online or via phone." },
  { question: "Do you provide pickup from Pune home or hotel?", answer: "Yes, we provide doorstep pickup from homes, hotels, offices, and Pune Airport." },
  { question: "Are vehicles cleaned regularly?", answer: "Yes, all vehicles are regularly cleaned and sanitized for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rakesh Verma",
    feedback:
      "Booked SRS Cab Service for Pune to Ujjain trip. Long journey was smooth and driver was very professional.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Pooja Sharma",
    feedback:
      "Excellent Pune to Ujjain cab service. Comfortable ride and perfect for family pilgrimage.",
    rating: 5
  }
];
































const Images = [
{ place: "/images/keyword/1.jpg", text: "Pune Cab Service", link: "Pune-Cab-Service" },
{ place: "/images/keyword/2.jpg", text: "Pune Taxi Hire", link: "Pune-Taxi-Hire" },
{ place: "/images/keyword/3.jpg", text: "Pune Online Cabs Booking", link: "Pune-Online-Cabs-Booking" },
{ place: "/images/keyword/4.jpg", text: "Best Cabs Service in Pune", link: "Best-Cabs-Service-in-Pune" },
{ place: "/images/keyword/5.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
{ place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
{ place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cab", link: "Pune-to-Mahabaleshwar-Cab" },
{ place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab", link: "Pune-to-Lonavala-Cab" },
{ place: "/images/keyword/9.jpg", text: "Pune to Trimbakeshwar Cab", link: "Pune-to-Trimbakeshwar-Cab" },
{ place: "/images/keyword/10.jpg", text: "Pune to Shirdi Cab", link: "Pune-to-Shirdi-Cab" },
{ place: "/images/keyword/11.jpg", text: "Pune to Bhimashankar Cab", link: "Pune-to-Bhimashankar-Cab" },
{ place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
{ place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cab", link: "Pune-to-Konkan-Darshan-Cab" },
{ place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
{ place: "/images/keyword/15.jpg", text: "Pune Outstation Cabs", link: "Pune-Outstation-Cabs" },
{ place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab", link: "Pune-to-Panchgani-Cab" },
{ place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Cab", link: "Pune-to-Mumbai-International-Airport-Cab" },
{ place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab", link: "Ashtavinayak-Darshan-Cab" },
{ place: "/images/keyword/19.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
{ place: "/images/keyword/20.jpg", text: "Pune to Goa Cab", link: "Pune-to-Goa-Cab" },
{ place: "/images/keyword/21.jpg", text: "Pune to Ajanta Ellora Cab", link: "Pune-to-Ajanta-Ellora-Cab" },
{ place: "/images/keyword/22.jpg", text: "Pune to Satara Cabs", link: "Pune-to-Satara-Cabs" },
{ place: "/images/keyword/23.jpg", text: "Pune Airport Cabs", link: "Pune-Airport-Cabs" },
{ place: "/images/keyword/24.jpg", text: "Pune to Ayodhya Tour Package", link: "Pune-to-Ayodhya-Tour-Package" },
{ place: "/images/keyword/25.jpg", text: "Corporate Cab Service in Pune", link: "Corporate-Cab-Service-in-Pune" },
];














const jsonData = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Ujjain Cab | SRS Cab",
  "description": "SRS Cab provides Pune to Ujjain cab services including one-way and round trips, taxi booking, car hire, and outstation travel. Book safe, comfortable, and affordable rides from Pune to Ujjain with 24x7 online booking, professional drivers, and reliable service.",
  "brand": {
    "@type": "Brand",
    "name": "SRS Cab"
  },
  "offers": {
    "@type": "Offer",
    "url": "https://www.srscabservice.com/",
    "priceCurrency": "INR",
    "availability": "https://schema.org/InStock"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "2450"
  }
};




  return (
    <div>
      
<Helmet>
  <title>Pune to Ujjain Cab | Call +91 9011955415 | SRS Cab</title>
  <meta 
    name="description" 
    content="Book Pune to Ujjain cabs with SRS Cab. One-way, round trips, taxi booking, car hire, and outstation travel with 24x7 online booking. Safe, comfortable, and affordable rides from Pune to Ujjain." 
  />
  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>



 <div className="breadcrumb-bar">
      <div className="container">
        <div className="row align-items-center text-center">
          <div className="col-md-12 col-12">
            <h2 className="breadcrumb-title"> {cardData.keyword}</h2>
           
          </div>
        </div>
      </div>
    </div>




      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/33.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#030706', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Srs Cab Service: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}
              
     <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                  
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

              
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2 d-flex">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
               <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Srs Cab Service</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Srs Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                        //   title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
  <h4 className="pc-title">Contact Information</h4>

  <div className="pc-grid">
    {/* Phones */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-telephone-fill"></i>
        <span>Phone Numbers</span>
      </header>

      <div className="pc-list">
        <a href="tel:+919011955415" className="pc-call">+91 9011955415</a>
      </div>

      <div className="pc-cta">
        <a
          href="https://wa.me/919011955415"
          target="_blank"
          rel="noopener noreferrer"
          className="pc-whats"
        >
          <i className="bi bi-whatsapp"></i> WhatsApp
        </a>
        <a href="tel:+919011955415" className="pc-primary">
          Call Now
        </a>
      </div>
    </section>

    {/* Email */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-envelope-fill"></i>
        <span>Email</span>
      </header>

      <a href="mailto:booking@srscabservice.com" className="pc-email">
        booking@srscabservice.com
      </a>
    </section>

    {/* Address */}
    <section className="pc-tile">
      <header className="pc-tile-head">
        <i className="bi bi-geo-alt-fill"></i>
        <span>Address</span>
      </header>

      <address className="pc-address">
        <strong>Srs Cab Service</strong><br />
        Office no. 3 Mankar corner, kaspate chowk wakad Pune 411027
      </address>
    </section>
  </div>
</div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoujjaincab;